import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { useQuery } from 'convex/react';
import { api } from '../lib/convex';
import { Zap, Star, Sparkles } from 'lucide-react';
import { SERVICE_TIERS } from '../../convex/constants/serviceTiers';

export default function TierBadge() {
  const { user } = useUser();
  const preferences = useQuery(api.posts.getUserPreferences);
  
  const tier = (preferences?.serviceTier || user?.privateMetadata?.serviceTier || 'free') as keyof typeof SERVICE_TIERS;
  
  const badges = {
    free: { icon: Star, color: 'bg-gray-100 text-gray-800 hover:bg-gray-200' },
    pro: { icon: Zap, color: 'bg-blue-100 text-dogblue hover:bg-blue-200' },
    enterprise: { icon: Zap, color: 'bg-purple-100 text-purple-800 hover:bg-purple-200' },
    enterpriseVIP: { 
      icon: Sparkles, 
      color: 'bg-gradient-to-r from-orange-200 via-yellow-100 to-orange-200 text-dogbrown border border-yellow-300/30 shadow-[0_0_15px_rgba(217,151,75,0.4)]'
    },
  };

  const { icon: Icon, color } = badges[tier];

  return (
    <div className={`relative hidden sm:inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${color} ${
      tier === 'enterpriseVIP' ? 'backdrop-blur-sm' : ''
    }`}>
      {tier === 'enterpriseVIP' && (
        <>
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-orange-200/20 via-yellow-200/20 to-orange-200/20 animate-pulse" />
          <Sparkles className="absolute -left-1 -top-1 w-3 h-3 text-dogbrown animate-twinkle" />
          <Sparkles className="absolute -right-1 -bottom-1 w-3 h-3 text-dogbrown animate-twinkle-delayed" />
        </>
      )}
      {tier === 'free' ? (
        <Star className="w-3.5 h-3.5 mr-1.5 text-gray-600" />
      ) : tier === 'enterpriseVIP' ? (
        <Sparkles className="w-3.5 h-3.5 mr-1.5 drop-shadow-[0_0_3px_rgba(217,151,75,0.5)]" />
      ) : (
        <Icon className="w-3.5 h-3.5 mr-1.5" />
      )}
      <span className={tier === 'enterpriseVIP' ? 'drop-shadow-[0_0_3px_rgba(217,151,75,0.6)]' : ''}>
        {SERVICE_TIERS[tier].name}
      </span>
    </div>
  );
}